import _Polygon from "./Polygon";
import _DummyCollection from "./sensors/DummyCollection";
import _HeatMap from './HeatMap';
import {AQIMarker as _AQIMarker} from './AQIMarker';

export const Polygon = _Polygon;
export const DummyCollection = _DummyCollection;
export const HeatMap = _HeatMap;
export const AQIMarker = _AQIMarker;




// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/index.js